import { type FC, useMemo } from "react";
import { useMatchMinute } from "../../../../hooks/use-match-minute";
import { type Post, PostType } from "../../../../types/post.types";
import PostFooter from "../../components/post-footer/post-footer";
import PostHeader from "../../components/post-header/post-header";
import PostText from "../../components/post-text/post-text";
import * as CSS from "./game-event-post.styles";

type StandardPostProps = {
	post: Post;
};

const GameEventPost: FC<StandardPostProps> = ({ post }) => {
	const getTitle = useMemo(() => {
		if (post.type === PostType.PENALTY) {
			return "Penalty!";
		}

		if (post.type === PostType.VAR) {
			return "VAR decision";
		}
	}, [post]);

	const minute = useMatchMinute(post.date, post.minute);

	return (
		<CSS.Post>
			<PostHeader time={minute} type={post.type} />
			<div style={{ marginLeft: 44 }}>
				<CSS.Title>{getTitle}</CSS.Title>
				<PostText postId={post.id} text={post.text} />
				<PostFooter postId={post.id} postType={post.type} />
			</div>
		</CSS.Post>
	);
};

export default GameEventPost;
